import { render, staticRenderFns } from "./PersonnelNew.vue?vue&type=template&id=6a486148&scoped=true&"
import script from "./PersonnelNew.vue?vue&type=script&lang=js&"
export * from "./PersonnelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a486148",
  null
  
)

export default component.exports